import React from "react";
import { useEffect, useState } from "react";
import { TextareaAutosize } from "@mui/material";
import { PaperCard } from "../../../shared/ui/paper-card/paper-card.component";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import {
  UseCreatePericiaCommentProps,
  useCreatePericiaComment
} from "../../../features/pericia-comment/create-pericia-comment/api/useCreatePericiaComment";

interface CreatePericiaCommentProps {
  props: Props;
}

interface Props {
  periciaId: string;
  done: boolean;
  createdPericiaComment: () => void;
}

const CreatePericiaComment: React.FC<CreatePericiaCommentProps> = ({ props }) => {
  const { periciaId, done, createdPericiaComment } = props;
  const [userComment, setUserComment] = useState<string>("");
  const [comment, setComment] = useState<UseCreatePericiaCommentProps>({
    comment: "",
    id_pericia: ""
  });
  const {
    data: createPericiaCommentRes,
    error: errorCreatingPericiaComment,
    isLoading: isLoadingCreatingComment
  } = useCreatePericiaComment(comment);

  useEffect(() => {
    if (!createPericiaCommentRes) return;
    createdPericiaComment();
    setComment({ comment: "", id_pericia: "" });
    setUserComment("");
    toast.success("Comentário adicionado com sucesso!", { autoClose: 800 });
  }, [createPericiaCommentRes, createdPericiaComment]);

  const handleCreateComment = () => {
    if (userComment.length === 0) return;
    setComment({ comment: userComment, id_pericia: periciaId });
  };

  if (errorCreatingPericiaComment) {
    toast.error("Erro ao adicionar comentário!", { autoClose: 800 });
  }

  return (
    <PaperCard title="Criar observação [compartilhada com técnico] sobre a perícia">
      <TextareaAutosize
        aria-label="minimum height"
        minRows={3}
        placeholder="Observações..."
        value={userComment}
        onChange={(e) => {
          setUserComment(e.target.value);
        }}
        style={{ width: "100%", marginTop: "1rem", padding: "1rem 1rem 0.5rem 1rem" }}
      />
      <LoadingButton
        fullWidth
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleCreateComment}
        disabled={userComment.length === 0}
        loading={isLoadingCreatingComment}
      >
        Salvar comentário
      </LoadingButton>
    </PaperCard>
  );
};

export default CreatePericiaComment;
